import MyFriendshipRequest from './MyFriendshipRequest';
import AcceptFriendship from './AcceptFriendship';

const UserMenuExtension = () => (
  <>
    <div className='divider'></div>
    <div>Envoyer une demande d'amitié</div>
    <MyFriendshipRequest />
    <div className='divider'></div>
    <div>Recevoir une demande d'amitié</div>
    <AcceptFriendship />
  </>
);

export default UserMenuExtension;
